@use "~theme/breakpoints";
@use "~theme/typography";

.patientSpace {
  margin-top: 10px;
}

@mixin two-columns {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  > * {
    flex: 1;
    margin-left: 8px;
  }

  > :first-child {
    margin-left: 0;
    margin-right: 8px;
  }
}
.dob {
  > :first-child {
    margin-right: 0px !important;
  }
}
.header {
  @include typography.heading3;
  margin-bottom: 10px;
}

.container {
  background-color: var(--white);
  padding: var(--mobile-gutter);
  flex-grow: 1;
  max-width: var(--max-desktop-width);
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray03);

  @include breakpoints.desktop {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.form {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.buttons {
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;

  > :last-child {
    margin-right: 0;
  }

  > :first-child {
    margin-left: 0;
  }
}

.button {
  margin: 0 8px;
}

.twoColumns {
  @include two-columns;
  
  input {
    @include breakpoints.desktop {
      //width: 400px;
    }
  }
}

.desktopTwoColumns {
  @include breakpoints.desktop {
    @include two-columns;
  }

  input {
    @include breakpoints.desktop {
      //width: 400px;
    }
  }
}

.smsHelp {
  @include typography.caption;
  margin: 0 0 24px;
  color: var(--black-at-75);

  a {
    color: var(--black-at-75);
  }
}

.agreeText {
  color: var(--black-at-75); 
}

.tooltipHavingError {
  margin-bottom: 44px;

  @include breakpoints.desktop {
    margin-bottom: 0;
  }
}

.tooltipText {
  margin: 0;
}

.layout {
  padding: 20px var(--mobile-gutter);

  @include breakpoints.desktop {
    width: 68%;
  }

  p {
    min-height: 0px;
    @include breakpoints.desktop {
     // min-height: 43.2px;
    }
  }
}

.headline {
  @include typography.heading3;
  margin: 0;
  margin-bottom: 15px;

  @include breakpoints.desktop {
    margin-bottom: 0px;
  }
}

.divider {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    margin: 0px;
    border: none;
    border-bottom: 4px solid var(--blue-01);
    max-width: 9.5em;
  }
}

.actionSlot {
  margin-top: 24px;
}

.asterisk {
  color: red;
}
